import { PropsWithChildren } from 'react'

import { PrimaryCell, PrimaryCellProps, TableData } from '@revolut-internal/ui-kit-table'

type SelectableCellProps<Data extends TableData> = PrimaryCellProps<Data> & {
  isSelected?: boolean
}

export const SelectableCell = <Data extends TableData>({
  isSelected = false,
  onClick,
  ...props
}: PropsWithChildren<SelectableCellProps<Data>>) => {
  return (
    <PrimaryCell
      data-cell-selected={isSelected}
      style={{
        height: '100%',
      }}
      data-cell-selectable
      onClick={onClick}
      {...props}
    />
  )
}
